import { render, staticRenderFns } from "./EditorExpresiones.vue?vue&type=template&id=ebc875ec&scoped=true"
import script from "./EditorExpresiones.vue?vue&type=script&lang=js"
export * from "./EditorExpresiones.vue?vue&type=script&lang=js"
import style0 from "./EditorExpresiones.vue?vue&type=style&index=0&id=ebc875ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc875ec",
  null
  
)

export default component.exports